export class StringConstants {
  public static readonly EMPTY_STRING: string = '';
  public static readonly CALCULATE_FEE_TEXT: string = 'Calculate Fee';
  public static readonly MODIFY_EXCHANGE_TEXT: string = 'Modify Exchange';

  public static readonly ENTER_SETTLEMENT_DATE_TEXT: string = 'Enter Settlement Date';
  public static readonly CHECK_BALANCES_TEXT: string = 'Check Balances';
  public static readonly REVIEW_TEXT: string = 'REVIEW';

  public static readonly EXCHANGE_TYPE_SMBS: string = 'EXPD-SMBS';

  //at settelment takedown feature
  public static readonly EXCHANGE_TYPE_PREDEFINED_SMBS = 'PREDEF-SMBS';
  public static readonly EXCHANGE_TYPE_REMIC = 'REMIC';
  public static readonly EXCHANGE_TYPE_AT_SETTLE_EXPD_SMBS = 'AT-SETTLE-EXPD-SMBS';
  public static readonly EXCHANGE_TYPE_AT_SETTLE_PREDEFINED_SMBS = 'AT-SETTLE-PREDEF-SMBS';
  public static readonly EXCHANGE_TYPE_AT_SETTLE_REMIC = 'AT-SETTLE-REMIC';
  public static readonly SUBMIT_TAKEDOWN = 'SUBMIT TAKEDOWNS';
  public static readonly MODIFY_TAKEDOWN = 'Modify Takedown';
  public static readonly CLEAR_ALL_FIELD_TEXT: string = 'CLEAR ALL FIELDS';
  public static readonly REVIEW_TAKEDOWN: string = 'REVIEW TAKEDOWN';
  public static readonly REVIEW_EXCHANGE_DETAILS: string = 'Review Exchange Details';
  public static readonly REVIEW_TAKEDOWN_DETAILS: string = 'Review Takedown Details';
  public static readonly TAKEDOWN_STATUS_NEW: string = 'NEW';
  public static readonly TAKEDOWN_STATUS_SUBMITTED: string = 'SUBMITTED';

  //review & commit screen
  public static readonly COMMIT_EXCHANGE: string = 'COMMIT';
  public static readonly SUBMIT_EXCHANGE: string = 'SUBMIT';
  public static readonly CANCEL: string = 'CANCEL';

  public static readonly REVIEW_EXCHANGE_DETAILS_SUB_TEXT =
    'Below are the details of your exchange. You may go back to make changes or click the Commit button to finalize this transaction.';
  public static readonly REVIEW_TAKEDOWN_DETAILS_SUB_TEXT =
    'Below are the details of your takedown. You may go back to make changes or click the Commit button to finalize this transaction.';

  //confirmation screen
  public static readonly EXCHANGE_CONFIRMED: string = 'Exchange confirmed';
  public static readonly TAKEDOWN_CONFIRMED: string = 'Takedown confirmed';

  //message-alerts

  public static readonly MESSAGE_NOTICE: string = 'notice';
  public static readonly MESSAGE_INFO: string = 'info';
  public static readonly MESSAGE_ERROR: string = 'error';
  public static readonly MESSAGE_SUCCESS: string = 'success';

  //mega types
  public static readonly MEGA_TYPE_SINGLE_FAMILY_FIX = 'SFFIXMEGA';
  public static readonly MEGA_TYPE_SINGLE_FAMILY_ARM = 'SFARMMEGA';
  public static readonly MEGA_TYPE_MULTI_FAMILY_FIX = 'MFFIXMEGA';
  public static readonly MEGA_TYPE_MULTI_FAMILY_ARM = 'MFARMMEGA';
  public static readonly MEGA_TYPE_SINGLE_FAMILY_FIX_DESC = 'Single Family Fixed Rate';
  public static readonly MEGA_TYPE_SINGLE_FAMILY_ARM_DESC = 'Single Family ARM';
  public static readonly MEGA_TYPE_MULTI_FAMILY_FIX_DESC = 'Multi Family Fixed Rate';
  public static readonly MEGA_TYPE_MULTI_FAMILY_ARM_DESC = 'Multi Family ARM';

  //edit mega
  public static readonly MEGA_ENTER_DETAILS_SCREEN_SUB_HEADER = 'Enter Pool Details';
  public static readonly MEGA_ENTER_DETAILS_SCREEN_SUB_HEADER_EDIT = 'Edit Pool Details';
  public static readonly MEGA_ENTER_DETAILS_SCREEN_REVIEW_BUTTON_TEXT = 'REVIEW';
  public static readonly MEGA_ENTER_DETAILS_SCREEN_REVIEW_BUTTON_EDIT_TEXT = 'REVIEW CHANGES';

  //edit mega review screen
  public static readonly MEGA_REVIEW_AND_COMMIT_SCREEN_CANCEL_BTN_TEXT = 'Cancel';
  public static readonly MEGA_REVIEW_AND_COMMIT_SCREEN_CANCEL_EDIT_BTN_TEXT = 'Cancel Changes';

  // upload collateral
  public static readonly MEGA_UPLOAD_POOL_FILE_FORMAT_TEXT =
    'The file type did not match our requirements. Please ensure the file is in (.xlsx) format and try again.';
  public static readonly MEGA_UPLOAD_POOL_MULTIPLE_FILES_ERROR_TEXT =
    'Multiple files could not be uploaded. Only one file can be uploaded at a time.';

  public static readonly MEGA_VALIDATE_POOL_JOB_VALIDATION_STATUS = 'Validation Completed';
  public static readonly MEGA_VALIDATE_POOL_VALIDATION_STATUS_COMPLETE = 'Complete';
  public static readonly MEGA_VALIDATE_POOL_VALIDATION_STATUS_MEGA_ERROR = 'Pool Error';
  public static readonly MEGA_VALIDATE_POOL_VALIDATION_STATUS_POOL_ERROR = 'Collateral Pool Error';
  public static readonly MEGA_VALIDATE_POOL_VALIDATION_STATUS_FILE_ERROR = 'File Error';

  //Multiple Mega upload
  public static readonly MEGA_BULK_UPLOAD_ENTER_DETAILS_SCREEN_HEADER = 'Create a New Mega';
  public static readonly MEGA_BULK_UPLOAD_ENTER_DETAILS_SCREEN_SUB_HEADER = 'Enter Mega Details';
  public static readonly MEGA_BULK_REVIEW_AND_COMMIT_SCREEN_SUB_HEADER = 'Review Mega Details';
  public static readonly MEGA_BULK_CONFIRMATION_SUB_HEADER = 'Confirmation';

  //Multiple Mega Column Header Constants
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_PREFIX = 'Prefix';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_SUBTYPE = 'Subtype';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_COUPON = 'Coupon';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_HIGH_COUPON = 'High Coupon';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_LOW_COUPON = 'Low Coupon';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_DEAL_AMOUNT = 'Deal Amount';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_SETTLEMENT_DATE = 'Settlement Date';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_SETTLEMENT_DATE_TOOLTIP =
    'Please note, Megas and Supers cannot settle on weekends or holidays and must settle at least two business days in the future. If you would like to settle sooner, please contact Structured Transactions to discuss your options.';
  public static readonly MEGA_BULK_UPLOAD_COLUMN_HEADER_SETTLEMENT_DATE_ERROR_TOOLTIP =
    'You can only book Megas and Supers settling in one month at a time. Please edit and try again.';
  public static readonly ANALYZER_SHOW_EXTENSION_ERROR =
    'The file type did not match our requirements. Please ensure the file is in the correct format and try again';
  public static readonly ANALYZER_SHOW_FILE_EMPTY_ERROR =
    'The uploaded file did not contain any information. Please try again.';
  public static readonly ANALYZER_SHOW_CORRUPTED_FILE_ERROR =
    'There was an error opening your file. Please try again.';
  public static readonly ANALYZER_SHOW_BANNER_ERROR_MESSAGE =
    'The upload contained error(s). An error report has been generated below to help you to resolve the issues. Please revise your file and upload again.';
  public static readonly ANALYZER_SHOW_PASSWORD_PROTECTED_FILE_ERROR =
    'This is a password protected file. Please unlock your file and try again.';
  public static readonly ANALYZER_SHOW_MISSING_DATA_ERROR_MESSAGE =
    'The file is missing data in one or more required columns';
  public static readonly ANALYZER_SHOW_MISSING_DATA_COLUMN_ERROR_MESSAGE =
    'Data is missing for one of the columns in the following rows ';
  public static readonly ANALYZER_SHOW_CUSIP_COLUMN_INVALID_FORMAT_ERROR_MESSAGE =
    'The CUSIP value in the defined "CUSIP" column ';
  public static readonly ANALYZER_SHOW_OFACE_COLUMN_INVALID_FORMAT_ERROR_MESSAGE =
    'The Original Face value in the defined "Original Face" column ';
  public static readonly ANALYZER_INTRO_DISCLOSURE_TEXT =
    'Upload your collateral to generate preliminary disclosure information and create Megas/Supers*.';
  public static readonly ANALYZER_INTRO_FACTORS_TEXT =
    'Please note, the Collateral Analyzer is available monthly after factors are disclosed until the end of month.';
  public static readonly ANALYZER_INTRO_ASTERISK_TEXT =
    '* All Megas/Supers created via this tool must be at least T+1. Create Megas/Supers from Collateral function will be disabled for the last business day of each month.';
  //Collateral Analyzer
  public static readonly COLLATERAL_ANALYZER_DELETE_MESSAGE =
    'You are attempting to delete collateral within this application. This change will not be saved to the original uploaded collateral file.';
  public static readonly COLLATERAL_ANALYZER_DELETE_ALL_MESSAGE =
    'You are attempting to delete ALL the collateral uploaded into this application. None of your uploaded collateral data will be saved and you will be redirected to the Collateral Analyzer file upload page. This change will not be saved to the original uploaded collateral file.';
  public static readonly COLLATERAL_ANALYZER_ADD_MESSAGE =
    'NOTE: Collateral added within this application will not be saved to the original uploaded collateral file.';
  public static readonly COLLATERAL_ANALYZER_EDIT_MESSAGE =
    'NOTE: Edits made within this application will not be saved to the original uploaded collateral file.';
  public static readonly ANALYZER_CUSIP_FORMAT_ERROR =
    'The CUSIP value is not in the proper format.';
  public static readonly ANALYZER_OFACE_FORMAT_ERROR =
    'The Original Face value is not in the proper format.';
  public static readonly ANALYZER_OFACE_LESS_THAN_1000_FORMAT_ERROR =
    'The Original Face value must be >=$1000.';
  public static readonly ANALYZER_CREATE_MEGA_DISABLE_TOOLTIP_TEXT =
    'Megas/Supers created via this tool must be at least T+1. This feature is available until 11 pm the day before the last business day of the month. For same-day Megas or Supers, please contact Structured Transactions.';

  public static readonly ANALYZER_DISCLOSURE_DATA_ERROR =
    'Preliminary disclosure data is currently not available for the collateral.';

  public static readonly ANALYZER_PRELIMINARY_DISCLOSURE_TEXT =
    '* Disclosure data herein is preliminary and subject to change.';

  public static readonly ANALYZER_DETAILS_ERROR_BANNER_MESSAGE =
    "Some data attributes were not loaded. To resolve this issue, try reloading your collateral file using the 'replace' link above.";

  //disclosure attribute mapping
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_REFINANCE_CASH_OUT = 'C';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_REFINANCE_CASH_OUT =
    'Refinance - Cash Out';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_REFINANCE_NO_CASH_OUT = 'N';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_REFINANCE_NO_CASH_OUT =
    'Refinance - No Cash Out';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_REFINANCE_NOT_SPECIFIED = 'R';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_REFINANCE_NOT_SPECIFIED =
    'Refinance - Not Specified';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_PURCHASE = 'P';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_PURCHASE = 'Purchase';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_MODIFIED_LOSS_MITIGATION = 'M';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_MODIFIED_LOSS_MITIGATION =
    'Modified - Loss Mitigation';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_ERRORCODE = '9';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_ERRORCODE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_CODE_NOT_AVAILABLE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_LOAN_PURPOSE_LABEL_NOT_AVAILABLE = 'Not Available';

  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_COOPERATIVE = 'CP';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_COOPERATIVE = 'Cooperative';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_CONDOMINIUM = 'CO';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_CONDOMINIUM = 'Condominium';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_PLANNED_UNIT = 'PU';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_PLANNED_UNIT = 'Planned Unit';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_SINGLE_FAMILY = 'SF';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_SINGLE_FAMILY = 'Single Family';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_MANUFACTURED_HOUSING = 'MH';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_MANUFACTURED_HOUSING =
    'Manufactured Housing';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_ERRORCODE = '99';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_ERRORCODE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_CODE_NOT_AVAILABLE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_PROPERTY_TYPE_LABEL_NOT_AVAILABLE = 'Not Available';

  public static readonly ANALYZER_DISCLOSURE_CHANNEL_CODE_RETAIL = 'R';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_LABEL_RETAIL = 'Retail';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_CODE_BROKER = 'B';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_LABEL_BROKER = 'Broker';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_CODE_CORRESPONDENT = 'C';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_LABEL_CORRESPONDENT = 'Correspondent';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_CODE_THIRD_PARTY_ORIGINATION = 'T';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_LABEL_THIRD_PARTY_ORIGINATION =
    'Third Party Origination - Not Specified';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_CODE_ERRORCODE = '9';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_LABEL_ERRORCODE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_CODE_NOT_AVAILABLE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_CHANNEL_LABEL_NOT_AVAILABLE = 'Not Available';

  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_CODE_PRIMARY_HOME = 'P';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_LABEL_PRIMARY_HOME = 'Primary Home';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_CODE_SECONDARY_HOME = 'S';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_LABEL_SECONDARY_HOME =
    'Secondary Home';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_CODE_INVESTMENT_PROPERTY = 'I';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_LABEL_INVESTMENT_PROPERTY =
    'Investment Property';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_CODE_ERRORCODE = '9';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_LABEL_ERRORCODE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_CODE_NOT_AVAILABLE = 'Not Available';
  public static readonly ANALYZER_DISCLOSURE_OCCUPANCY_STATUS_LABEL_NOT_AVAILABLE = 'Not Available';
  public static readonly SETTLED_LISTING_DEFAULT_DISCLOSURE_URL = '';

  //logout URL
  public static readonly LOGOUT_DEV_URL =
    'https://fmsso-devl.fanniemae.com/idp/startSLO.ping?TargetResource=';
  public static readonly LOGOUT_TEST_URL =
    'https://fmsso-test.fanniemae.com/idp/startSLO.ping?TargetResource=';
  public static readonly LOGOUT_ACPT_URL =
    'https://fmsso-acpt.fanniemae.com/idp/startSLO.ping?TargetResource=';
  public static readonly LOGOUT_PROD_URL =
    'https://fmsso.fanniemae.com/idp/startSLO.ping?TargetResource=';
  public static readonly LOGOUT_LOCALHOST_URL =
    'http://localhost:4200/idp/startSLO.ping?TargetResource=';

  //environment names
  public static readonly DEV_ENV = 'devl';
  public static readonly TEST_ENV = 'test';
  public static readonly ACPT_ENV = 'acpt';
  public static readonly PROD_ENV = 'prod';
  public static readonly ACPT_CNTG_ENV = 'acnt';
  public static readonly LOCALHOST_ENV = 'localhost';

  //REMIC file upload for ST pricing
  public static readonly FILE_UPLOAD_STATUS = 'COMPLETED';
  public static readonly FILE_READ_DELAY = 11000;
  public static readonly FILE_TYPE_ALLOWED = 'xls';

  //Health Check
  public static readonly HEALTH_CHECK_SCREEN_IDLE_TIME = 25; // in min
  public static readonly HEALTH_CHECK_POLL_INTERVAL = 2; // in min
  public static readonly HEALTH_CHECK_LOGOUT_TIMER = 300; // in seconds

  //Disclaimer
  public static readonly SUPERS_PREFIX_FEE_DISCLAIMER =
    '* The actual fee for this Supers will be computed based on the composition of Fannie and Freddie collateral backing the Supers. The actual fee will be communicated via the Collateral Delivery Instructions Report sent by STO_Megas@fanniemae.com';
  public static readonly DISABLED_DEALLOCATE_TEXT =
    'You cannot deallocate this deal at this time, please contact Fannie Mae at STO_MEGAS@fanniemae.com or 202-752-4800 for assistance';
  public static readonly freddieComputedFeeDisclaimer = (tickValue: number): string =>
    `* The fee for this Supers is based on the composition of Fannie and Freddie collateral backing the Supers. There is an additional ${tickValue} tick fee on the Freddie portion of the collateral.`;
}
